import { render } from "./DatePickerButton.vue?vue&type=template&id=b8004ae8&scoped=true"
import script from "./DatePickerButton.vue?vue&type=script&lang=js"
export * from "./DatePickerButton.vue?vue&type=script&lang=js"

import "./DatePickerButton.vue?vue&type=style&index=0&id=b8004ae8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8004ae8"]])

export default __exports__